export default "__VITE_PUBLIC_ASSET__6f3e2cff__"